export default function LandingSection({ title, description, children }) {
  return (
    <section className="testimonial-section padding-bottom overflow-hidden">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-xl-6">
            <div className="section-header text-center">
              <h2 className="section-header__title">{title}</h2>
              <p className="pb-5">{description}</p>
            </div>
          </div>
        </div>
        {children}
      </div>
    </section>
  );
}
